export function reconcileMessageGrouping(target) {
    const contentWrapper = target.hasClass('g-chatform-content')
        ? target
        : target.closest('.g-chatform-content');

    if (!contentWrapper.length) {
        return;
    }

    const messages = contentWrapper
        .find('.g-chatform-message')
        .not('.is-pending-response');

    messages.removeClass(
        'is-group-start is-group-end is-grouped-with-previous is-grouped-with-next'
    );

    let previousMessage = null;
    let previousRole = null;

    messages.each(function () {
        const currentMessage = jQuery(this);
        const currentRole = currentMessage.attr('data-role') ?? '';

        currentMessage.addClass('is-group-start is-group-end');

        if (previousMessage && previousRole === currentRole) {
            previousMessage.removeClass('is-group-end').addClass('is-grouped-with-next');
            currentMessage.removeClass('is-group-start').addClass('is-grouped-with-previous');
        }

        previousMessage = currentMessage;
        previousRole = currentRole;
    });
}
